export const SKELETON = {
  width: 80,
  height: 12,
};

export const CLASSNAME =
  'mt-2.5 text-style-h-em text-neutral-900 flex flex-start flex-wrap align-center items-center';
